import { getInfo } from '@Components/Grid/components/Table/formatters';

import ScrubOptions from '../../ScrubOptions';

export default function ThrottlingFormatter({ info }) {
  const { row, value } = getInfo(info)
  return <ScrubOptions.ThrottlingGridResume throttling={row.throttling || {}}>
    Scrub {value}%
  </ScrubOptions.ThrottlingGridResume>
}
